import { Creator } from '@/models/creator';

const RESTRICTION_SOURCE_TEXT: Record<Creator.Restriction['source'], string> = {
  creator: 'Set by the creator',
  platform: 'Applied by the platform',
  unknown: 'Applied by an unknown source'
};

const RESTRICTION_TYPE_TEXT: Record<Creator.Restriction['type'], string> = {
  age: 'Age restriction',
  audience_controls: 'Audience controls',
  adult_account: 'Adult account',
  unknown: 'Unknown restriction',
  location: 'Location restriction'
};

const getRestrictionTitle = ({
  legacy,
  type,
  level,
  accountName
}: Creator.Restriction) => {
  const label = legacy
    ? 'Age-gated'
    : RESTRICTION_TYPE_TEXT[type] ?? 'Restriction';
  if (level === 'account' && accountName) return `${label} · @${accountName}`;
  return label;
};

export const getRestrictionParts = (restriction: Creator.Restriction) => {
  const { legacy, source, level } = restriction;

  return {
    title: getRestrictionTitle(restriction),
    detail: legacy
      ? 'Historical record'
      : `${RESTRICTION_SOURCE_TEXT[source]} at ${level} level`
  };
};

export const getRestrictionText = (restriction: Creator.Restriction) => {
  const { title, detail } = getRestrictionParts(restriction);
  return `${title} · ${detail}`;
};
